import moment from 'moment';
import React from 'react';
import StatusBadge from '../../Components/StatusBadge/StatusBadge';
import Table from '../../Components/Table/Table';
import './PointHistory.scss'
import 'moment/locale/ko'
import { Link } from 'react-router-dom';

const statusList = {
    Cancel : '취소',
    Call : '호출',
    Done : '입장완료',
    Pending : '대기중'
}

const variant = {
    Pending : 'primary',
    Call : 'normal',
    Cancel : 'danger',
    Done : 'success'
}

const WaitingHistory = () => {

    const columnsPoint = React.useMemo(
        () => [
          {
            Header: '신청일시',
            accessor: 'RegDate.$date', // accessor is the "key" in the data
            disableFilters : true,
            width : 110,
            minWidth : 110,
            Cell : (props) => {
                return(
                    <p>{moment(props.cell.value).utc().locale('ko').format('YY-MM-DD(dd) HH:mm')}</p>
                )
            }
          },
          {
            Header: '유저번호',
            accessor: 'UserInfo',
            disableSortBy : true,
            minWidth : 140,
            width : 140,
            Cell : (props) => {
                if(typeof props.cell.value !== 'undefined'){
                    return(
                        <Link to={`/user-info/${props.cell.value._id.$oid}`}>
                            <p style={{ color : '#f95f53'}}>{props.cell.value.Tel}</p>
                        </Link>    
                    )
                }else {
                    return(
                        <p style={{ color : '#f95f53'}}>탈퇴한 회원</p>
                    )
                }
            }
          },
          {
            Header: '인원',
            accessor: 'Adult',
            disableFilters : true,
            minWidth : 110,
            width : 110,
            Cell : (props) => {
                return(
                    <p>성인 {props.cell.value}명 {props.cell.row.original.Baby > 0 ? `, 유아 ${props.cell.row.original.Baby}명` : ''}</p>
                )
            }
        },
        {
            Header: '입장일시',
            accessor: 'DoneDate.$date',
            disableFilters : true,
            minWidth : 140,
            width : 140,
            Cell : (props) => {
                if(typeof props.cell.value !== 'undefined'){
                    return(
                        <p>{ moment(props.cell.value).utc().locale('ko').format('YY-MM-DD(dd) HH:mm')}</p>
                    )
                }else {
                    return(
                        <p>-</p>
                    )
                }
                
            }
        },
        {
            Header: '상태',
            accessor: 'Status',
            minWidth : 100,
            width : 100,
            maxWidth : 100,
            disableFilters : true,
            isDropdown : false,
            Cell : (props) => {
                return(
                    <StatusBadge Status={statusList[props.cell.value]} variant={variant[props.cell.value]}/>
                )
            },
        },
        ],[]
    )

    return (
        <div className='waiting-history'>
            <Table key={'waiting'} columns={columnsPoint} url={'/api/history/waiting'}/>
        </div>
    )
}

export default WaitingHistory;